import { render, staticRenderFns } from "./CheckupsSchedule.vue?vue&type=template&id=3300414d&"
import script from "./CheckupsSchedule.vue?vue&type=script&lang=js&"
export * from "./CheckupsSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports